import { render, staticRenderFns } from "./inviteMain.vue?vue&type=template&id=6b937536"
import script from "./inviteMain.vue?vue&type=script&lang=js"
export * from "./inviteMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports